import React, { useEffect, useState } from "react";
import * as S from '../scss/theme';
import fnc from "../mymod/commFunction";
import './Assess_book_app.scss';
import HongButton from "../comm/HongButton";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Checkbox from '@mui/material/Checkbox';
import HeaderTitle from "../comm/HeaderTitle";
import fncSql from "../mymod/commFunctionSql";
import { setSelectedTestCode, setSelectedStCode } from "../reduxToolkit/reduxIgong";

const Assess_book_app = () => {
  
  const userInfo = useSelector((state) => state.reduxIgong.userInfo);
  const selectedTestCode = useSelector((state) => state.reduxIgong.selectedTestCode);
  const selectedStCode = useSelector((state) => state.reduxIgong.selectedStCode);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    fncQuestion();
  }, []);

  function fncQuestion() {
    fnc.sendAxios('/igonAssess_ectRoutes/select/question', {}, (res) => {
      if (res && res.length > 0) {
        const listRes = getRecords(res);
        setList(listRes);
      } else {
        console.log("속성이 obj 내에 없습니다.");
      }
    });
  }

  function getRecords(res) {
    return res.map((item) => ({
      sno: item.sno,
      no: item.no,
      code: item.code,
      typeCode: item.typeCode,
      typeName: item.typeName,
      genre: item.genre,
      ability: item.ability,
    }));
  }

  function handleCheckboxChange(item) {
    const isSelected = selectedItems.some((selected) => selected.sno === item.sno);
    let newSelectedItems;

    if (isSelected) {
      newSelectedItems = selectedItems.filter((selected) => selected.sno !== item.sno);
    } else {
      newSelectedItems = [
        ...selectedItems,
        {
            sno: item.sno,
            no: item.no,
            code: item.code,
            typeCode: item.typeCode,
        },
      ];
    }

    setSelectedItems(newSelectedItems);
  }

  function handleSubmit() {
   
    const rtn = window.confirm('제출하시겠습니까?');
    if (!rtn) return;

    const testDate = fnc.fncDate();
    const stCode = selectedStCode;
    const testCode = fnc.fncSirialNum('BT');//이건 사용 안 함 (pTestCode로만 변경)
    const pTestCode = selectedTestCode;

    fncInsert_marking(pTestCode, testDate, stCode, testCode);
  }

  function fncInsert_marking(pTestCode, testDate, stCode, testCode) {
    fnc.sendAxios('/igonAssess_etcRoutes/insert/book_marking', { pTestCode, testDate, stCode, testCode }, (res) => {
      if (res) {
        if (res.success === 'exist') {
          alert(`${testDate}에 제출한 진단이 이미 존재합니다.`);
        } else if (res.success === true) {
          fncInsert_marking_value_total(pTestCode, testCode, stCode);
        }
      } else {
        alert('저장에 실패했습니다.');
      }
    });
  }

  function fncInsert_marking_value_total(pTestCode, testCode, stCode) {
    let cnt = 0;
    const tCnt = selectedItems.length;

    selectedItems.forEach((item) => {
      const value = 'Y';
      const munCode = item.code;
      const typeCode = item.typeCode;

      fncInsert_marking_value(pTestCode, testCode, stCode, munCode, typeCode, value, () => {
        cnt++;
        if (cnt === tCnt) {
          alert('완료되었습니다.');
          // navigate(-1); 
          
          fncGotoIgonChart(stCode, selectedTestCode);

          // if (isToken) {
          //     navigate('/myRoomSt');    
          // } else {
          //     navigate(-1);    
          // }
        }
      });
    });

    function fncInsert_marking_value(pTestCode, testCode, stCode, munCode,  typeCode, value, callback) {
      fnc.sendAxios('/igonAssess_etcRoutes/insert/book_marking_value', {
        pTestCode, testCode, stCode, munCode, typeCode, value, callback
      }, (res) => {
        if (res) {
          callback();
        } else {
          alert('저장에 실패했습니다.');
        }
      });
    }
  }

  function handleClose() {
    navigate(-1);
  }

  // ✅ 그룹핑된 리스트
  const groupedList = Object.entries(
    list.reduce((acc, item) => {
      acc[item.typeCode] = acc[item.typeCode] || [];
      acc[item.typeCode].push(item);
      return acc;
    }, {})
  );

  function fncGotoIgonChart(stCode, testCode) {
      fncSql.getUserInfo(dispatch, stCode, () => {
          dispatch(setSelectedTestCode(testCode));
          navigate('/iongChartApp');
        });
  }
  //========================================================
  return (
    <S.Section>
      <HeaderTitle title={'독서장르 진단평가'} direction={1} onBackClick={handleClose} />
      <div className="Assess_book_app">
        <div className="wrap-main">
          <section className="section-list">
    
            {groupedList.map(([typeCode, groupItems]) => (
             
              <div key={typeCode} className="type-group">
                <div className="title">*{groupItems[0]?.typeName}</div>
                <div className="book-flex-container">
              
                  {groupItems.map((item) => (
                    <div
                      key={item.sno}
                      className={`book-box ${selectedItems.some(sel => sel.sno === item.sno) ? 'selected' : ''}`}
                      onClick={() => handleCheckboxChange(item)}
                    >
                        <div className="genre">{item.genre}</div>
        
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </section>
        </div>

        <div className="box-menu">
          <HongButton className="btn h-btn-red" onClick={handleSubmit}>제출</HongButton>
        </div>
      </div>
    </S.Section>
  );
};

export default Assess_book_app;
